<template>
    <div class="project-heat-ranking">
        <div class="project-heat-ranking-header">
            <span class="hot-title">Most Searched Hashtags</span>
            <!-- <span @click="changeList" class="change-button"><i class="el-icon-refresh"></i>Exchange</span> -->
        </div>
        <div>
            <ul class="project-heat-ranking-list">
                <li v-for="(item, index) in value.content" :key="index">
                    <div class="left-wrap">
                        <span class="rank-index" :style="{'background': colorGet(index)}">{{index + 1}}</span>
                        <span class="hot-title" @click="handleClick(item)"
                              :title="item.word">{{item.word || '-'}}</span>
                        <span v-if="item.ishot" class="is-hot">hot</span>
                        <span v-if="item.isnew" class="is-new">new</span>
                    </div>
                    <!--                    <div class="item-count" :title="item.count">{{item.count}}</div>-->
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'hotList',
  props: {
    value: Object
  },
  methods: {
    changeList () {
      this.$emit('changeList')
    },
    colorGet (order) {
      const obj = ['#f54545', '#ff8547', '#ffac38', '#d0d7df']
      const color = obj[order] || obj[3]
      return color
    },
    handleClick (item) {
      this.$emit('click', {name: item.word})
    }
  }
}
</script>

<style scoped lang="scss">
    .project-heat-ranking {
        box-sizing: border-box;
        padding: 18px 24px;
        background: #ffffff;

        .project-heat-ranking-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;

            .hot-title {
                color: #343A40;
                font-size: 16px;
                font-weight: bolder;
            }

            .change-button {
                cursor: pointer;
                color: #0000cc;

                i {
                    margin-right: 5px;
                }
            }
        }

        .nano {
            height: calc(100% - 44px);
        }

        .project-heat-ranking-list {
            width: 100%;
            padding: 0;

            li {
                display: flex;
                align-items: center;
                height: 22px;
                line-height: 22px;
                font-size: 14px;
                justify-content: space-between;

                .left-wrap {
                    display: flex;
                    width: calc(100% - 50px);
                    align-items: center;
                }

                .rank-index {
                    display: inline-block;
                    padding: 2px 0;
                    color: #fff;
                    width: 16px;
                    line-height: 100%;
                    border-radius: 4px;
                    font-size: 12px;
                    text-align: center;
                    background-color: #8eb9f5;
                }

                .is-new {
                    padding: 2px;
                    background: #f13f40;
                    border-radius: 2px;
                    color: #ffffff;
                    font-size: 12px;
                }

                .is-hot {
                    padding: 2px;
                    background: #fc3274;
                    border-radius: 2px;
                    color: #ffffff;
                    font-size: 12px;
                }

                .item-count {
                    width: 50px;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .hot-title {
                    color: #0000cc;
                    margin-left: 5px;
                    width: calc(100% - 37px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                }

                /*.title:hover {*/
                /*  cursor: pointer;*/
                /*  border-bottom: 1px solid #0000cc;*/
                /*}*/
            }

            li + li {
                margin-top: 15px;
            }
        }
    }
</style>
